// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/financial/BankAddEditForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {bankAddItem, bankSetItem, bankGetItem} from "../../actions/financialActions";
import {reset} from "redux-form";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.financial.bankGetItem,
        userValue : state.app.currentUser,

    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        if(value.mode == 'edit')
            dispatch(edit(value));
        else
            dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {
    return (dispatch, getState) => {
        let formData = {
            'title'          : values.title,
            'account_number' : values.account_number,
            'bank_title'     : values.bank_title,
            'bank_logo'      : ''
        };
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('financial/bank-account', formData).then(res => {
            dispatch(bankAddItem(res.data));
            if(res.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                dispatch(reset('addBank'));
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const edit = (values) => {
    let id = values._id;

    return (dispatch, getState) => {
        let formData = {
            'title'          : values.title,
            'account_number' : values.account_number,
            'bank_title'     : values.bank_title,
            'bank_logo'      : ''
        };
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('financial/bank-account/'+id, formData).then(editRes => {
            dispatch(bankSetItem(editRes.data));
            if(editRes.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ویرایش'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const getItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('financial/bank-account/'+id).then(bankInfo => {
            dispatch(bankGetItem(bankInfo.data));
        }).catch(error => {
            console.log(error);
        });
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
